import EventBus from '@/eventBus'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import { IMPORT_DOCUMENT } from '@/constant/eventActions'

export default {
  handleAIGenerateSlideEvent(doc) {
    EventBus.$emit('slides-generator:generated', doc)
  },
  handleAIGenerateSlideError() {
    EventBus.$emit('slide-generator: ai_response_error')
  },
  handleAIGenerateTemplateDescription(doc) {
    EventBus.$emit('ai-template-description: generated', doc)
  },
  handleAIGenerateWordCloudSmartGrouping(doc) {
    EventBus.$emit('word-cloud-smart-grouping: generated', doc)
  },
  async handleDocToQuizGenerated(editor, doc) {
    if (!editor.docToQuizResultModalVisible) {
      editor.setDocToQuizResultModalVisibleAction(true)
    }
    await utils.sleep(500)
    EventBus.$emit('doc-to-quiz: generated', doc)
  },
  handleDocToQuizGenerationDone() {
    EventBus.$emit('doc-to-quiz: generation_done')
  },

  _trackDocToQuizGenerationDone(editor) {
    const eventAction = `${IMPORT_DOCUMENT} > Quiz generation success`
    const trackData = {
      eventAction,
      eventCategory: eventCategories.PRESENTATION_EDITOR,
      eventLabel: 'Generate quiz from doc',
      presentationId: editor.$store.state.presentation.id || null,
      userId: editor.$store.state.currentUser.id,
    }
    utils.trackGA4AndMixpanel(eventAction, trackData)
    editor.$store.state.docToQuizTrackGenerationDone = true
  },

  async _handleDocToQuizResult(doc, editor) {
    // Keep set state and $store.state like this, since mapActions is not working in this method, will refactor here: https://ahaslides.atlassian.net/browse/AHA-26127
    const hasData = doc.data && doc.data.length
    editor.$store.state.docToQuizResult = hasData ? doc.data : editor.$store.state.docToQuizResult
    editor.$store.state.docToQuizNewPresentationRequestId = doc.requestId ? doc.requestId
      : editor.$store.state.docToQuizNewPresentationRequestId
    this._trackDocToQuizGenerationDone(editor)
    await utils.sleep(2000)
    EventBus.$emit('checkToShowDocToQuizResult')
  },

  async handleDocToQuizGenerationDoneWhenGlobalImport(doc, editor) {
    // Keep set state and $store.state like this, since mapActions is not working in this method, will refactor here: https://ahaslides.atlassian.net/browse/AHA-26127
    if (!doc) return
    if (doc.error) {
      editor.$store.state.docToQuizGlobalImportError = true
      return
    }
    this._handleDocToQuizResult(doc, editor)
  },

  handleDocToQuizImportConvertError(doc) {
    EventBus.$emit('doc-to-quiz: import_convert_error', doc)
  },
  handleAIGenerateOpenEndedSmartGrouping(doc) {
    EventBus.$emit('open-ended-smart-grouping: generated', doc)
  },
  handleAIOpenEndedSmartGroupingSubmissionChange(doc) {
    EventBus.$emit('open-ended-smart-grouping: submission_change', doc)
  },
}
